import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Rect,
  Path,
  Circle,
  Defs,
  LinearGradient,
  Stop,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={51}
    height={35}
    viewBox={'0 0 51 35'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G filter="url(#a)">
      <Rect
        width={43}
        height={27}
        x={4}
        y={2}
        fill="url(#b)"
        fillOpacity={0.85}
        rx={13.5}
      />
    </G>
    <G filter="url(#c)">
      <Path stroke={props.fill || '#fff'} strokeLinecap="round" d="M15 9h21" />
    </G>
    <G filter="url(#d)">
      <Path stroke={props.fill || '#fff'} strokeLinecap="round" d="M15 16h21" />
    </G>
    <G filter="url(#e)">
      <Path stroke={props.fill || '#fff'} strokeLinecap="round" d="M15 23h21" />
    </G>
    <G filter="url(#f)" shapeRendering="crispEdges">
      <Circle cx={19} cy={9} r={2} fill="url(#g)" fillOpacity={0.85} />
      <Circle cx={19} cy={9} r={1.5} stroke={props.fill || '#fff'} />
    </G>
    <G filter="url(#h)" shapeRendering="crispEdges">
      <Circle cx={26} cy={16} r={2} fill="url(#i)" fillOpacity={0.85} />
      <Circle cx={26} cy={16} r={1.5} stroke={props.fill || '#fff'} />
    </G>
    <G filter="url(#j)" shapeRendering="crispEdges">
      <Circle cx={32} cy={23} r={2} fill="url(#k)" fillOpacity={0.85} />
      <Circle cx={32} cy={23} r={1.5} stroke={props.fill || '#fff'} />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={24.05}
        x2={24.05}
        y1={2}
        y2={29}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
      <LinearGradient
        id="g"
        x1={18.865}
        x2={18.865}
        y1={7}
        y2={11}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
      <LinearGradient
        id="i"
        x1={25.865}
        x2={25.865}
        y1={14}
        y2={18}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
      <LinearGradient
        id="k"
        x1={31.865}
        x2={31.865}
        y1={21}
        y2={25}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default SvgComponent;
